export const isNotEmpty = value => value && value.length > 0 ? undefined : 'This field is required';

export const hasFiveNums = value => value && value.match(/^\d{5}$/) ? undefined : 'Must be five digits';

const emailRegEx = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const isEmail = value => value && value.match(emailRegEx) ? undefined : 'Must be a valid email address';

export const isUSPhone = value => value && value.replace(/[-().]/g, '').match(/^\d{10}$/) ? undefined : 'Must be a valid phone number';
